<template>
    <div class="apply">
        <div class="client-banner">
            <img src="../../assets/images/banner5.jpg" alt="">
        </div>
        
        <!-- 中间内容 -->
        <div class="client_wrap">
            <p class="apply_p">视频数据管理系统（Video Data Man-agement System，即VDMS）是以人工智能为基础，专注于视频及图像处理的创新型产品，通过集成深度学习等多种人工智能技术，能够有效果处理体量大、有效信息分散、检索困难的非结构化视频数据，实现智能化</p>
            <div class="apply_listimg">
                <img src="../../assets/images/109.png" alt="">
                <img src="../../assets/images/110.png" alt="">
                <img src="../../assets/images/111.png" alt="">
            </div>
            <div class="line">方案架构</div>
            <p class="apply_p">VDMS视频数据管理系统支持国标GB/T 28181协议、ONVIF协议和视频行业标准，可以无缝对接视频监控系统，不改变原有视频架构，实现视频数据瘦身。</p>
            <div class="apply_img"><img src="../../assets/images/112.png" alt=""></div>
            <div class="line">行业方案</div>
            <div class="apply_listimg">
                <!-- 第一张图片 -->
                <div>
                    <div class="img_box">
                        <div class="img_opcity">
                            <span class="img_text">教育</span>
                            <ul>
                                <li><span></span>远距离压缩传输、互联网传输、级联传输</li>
                                <li><span></span>隐私保护</li>
                                <li><span></span>无损压缩、存储扩容</li>
                            </ul>
                        </div>
                        <img src="../../assets/images/113.png" alt="">   
                    </div>
                    <p class="apply_listp">教育</p>
                </div>
                <!-- 第二张图片 -->
                <div>
                    <div class="img_box">
                        <div class="img_opcity">
                            <span class="img_text">安防</span>
                            <ul>
                                <li><span></span>远距离压缩传输、4G传输、级联传输</li>
                                <li><span></span>无损压缩、存储扩容、“冷存储+”永久存储</li>
                                <li><span></span>视频溯源、信息封控</li>
                                <li><span></span>智能分析</li>
                            </ul>
                        </div>
                        <img src="../../assets/images/114.png" alt="">   
                    </div>
                    <p class="apply_listp">安防</p>
                </div>
                <!-- 第三张图片 -->
                <div>
                    <div class="img_box">
                        <div class="img_opcity">
                            <span class="img_text">交通</span>
                            <ul>
                                <li><span></span>远距离压缩传输、4G传输</li>
                                <li><span></span>无损压缩、存储扩容</li>
                                <li><span></span>车流量分析、车牌识别、车轨迹检测。</li>
                            </ul>
                        </div>
                        <img src="../../assets/images/115.png" alt="">   
                    </div>
                    <p class="apply_listp">交通</p>
                </div>
                <!-- 第四张图片 -->
                <div>
                    <div class="img_box">
                        <div class="img_opcity">
                            <span class="img_text">新零售</span>
                            <ul>
                                <li><span></span>人脸识别、身份识别</li>
                                <li><span></span>数据分析、数据结构化</li>
                            </ul>
                        </div>
                        <img src="../../assets/images/116.png" alt="">   
                    </div>
                    <p class="apply_listp">零售</p>
                </div>
                <!-- 第五张图片 -->
                <div>
                    <div class="img_box">
                        <div class="img_opcity">
                            <span class="img_text">园区</span>
                            <ul>
                                <li><span></span>远距离压缩传输、4G传输、互联网传输、级联传输</li>
                                <li><span></span>无损压缩、存储扩容</li>
                                <li><span></span>人流量统计</li>
                                <li><span></span>智能分析</li>
                            </ul>
                        </div>
                        <img src="../../assets/images/117.png" alt="">   
                    </div>
                    <p class="apply_listp">园区</p>
                </div>
                <!-- 第六张图片 -->
                <div>
                    <div class="img_box">
                        <div class="img_opcity">
                            <span class="img_text">能源</span>
                            <ul>
                                <li><span></span>远距离压缩传输、4G传输、级联传输</li>
                                <li><span></span>无损压缩、存储扩容</li>
                                <li><span></span>视频溯源</li>
                                <li><span></span>智能分析</li>
                            </ul>
                        </div>
                        <img src="../../assets/images/118.png" alt="">   
                    </div>
                    <p class="apply_listp">能源</p>
                </div>
                <!-- 第七张图片 -->
                <div>
                    <div class="img_box">
                        <div class="img_opcity">
                            <span class="img_text">金融</span>
                            <ul>
                                <li><span></span>远距离压缩传输、级联传输</li>
                                <li><span></span>无损压缩、存储扩容、“冷存储+”永久存储</li>
                            </ul>
                        </div>
                        <img src="../../assets/images/119.png" alt="">   
                    </div>
                    <p class="apply_listp">金融</p>
                </div>
                <!-- 第八张图片 -->
                <div>
                    <div class="img_box">
                        <div class="img_opcity">
                            <span class="img_text">地产</span>
                            <ul>
                                <li><span></span>远距离压缩传输、4G传输、互联网传输、级联传输</li>
                                <li><span></span>无损压缩、存储扩容</li>
                                <li><span></span>人流量统计</li>
                                <li><span></span>智能分析</li>
                            </ul>
                        </div>
                        <img src="../../assets/images/120.png" alt="">   
                    </div>
                    <p class="apply_listp">地产</p>
                </div>
                <!-- 第九张图片 -->
                <div>
                    <div class="img_box">
                        <div class="img_opcity">
                            <span class="img_text">科研单位</span>
                            <ul>
                                <li><span></span>远距离压缩传输、4G传输、级联传输</li>
                                <li><span></span>无损压缩、存储扩容、“冷存储+”永久存储</li>
                                <li><span></span>视频溯源</li>
                                <li><span></span>隐私保护</li>
                            </ul>
                        </div>
                        <img src="../../assets/images/121.png" alt="">   
                    </div>
                    <p class="apply_listp">科研单位</p>
                </div>
            </div>
            <div class="line">应用案例</div>
            <div class="apply_listimg" style="margin-bottom: 0px;">
                <div class="img_hover">
                    <router-link to="/text">
                        <img src="../../assets/images/122.png" alt="">
                        <p class="apply_listp">北京市建委环境检测</p>
                    </router-link>
                </div>
                <div class="img_hover">
                    <router-link to="/torter">
                        <img src="../../assets/images/123.png" alt="">
                        <p class="apply_listp">雪亮工程</p>
                    </router-link>
                </div>
                <div class="img_hover">
                    <router-link to="/sanne">
                        <img src="../../assets/images/124.png" alt="">
                        <p class="apply_listp">青岛市高清视频传输</p>
                    </router-link>
                </div>
                <div class="img_hover">
                    <router-link to="/solve">
                        <img src="../../assets/images/125.png" alt="">
                        <p class="apply_listp">四川省市智慧公共<br>安全系统</p>
                    </router-link>
                </div>
                <div class="img_hover">
                    <router-link to="/pythons">
                        <img src="../../assets/images/126.png" alt="">
                        <p class="apply_listp">IDC机房监控系统</p>
                    </router-link>
                </div>
                <div class="img_hover">
                    <router-link to="/police">
                    <img src="../../assets/images/127.png" alt="">
                    <p class="apply_listp">新疆公安局信息封控<br>视频溯源</p>
                    </router-link>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import $ from "../../../node_modules/jquery/dist/jquery.js";
import header from "../cuscom/header"; 
export default {
     beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
 .apply {
     background: #f0fcfd;
     color: #333333;
 }
 .client-banner {
     width: 100%;
     height: 486px;
 }
 .client-banner img {
     width: 100%;
     height: 100%;
 }


 /* 下方内容 */
.client_wrap {
    width: 1200px;
    margin: 0 auto;
    margin-top: 122px;
}

/* 内容 */
.apply_p {
    font-size: 18px;
    text-indent: 2em;
    margin-bottom: 58px;
}
/* 伸缩盒子布局 */
.apply_listimg {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 140px;
}

/* 分割线 */
.line {
  font-size: 35px;
  text-align: center;
  color: #000000;
  width: 1000px;
  position: relative;
  margin-left: 100px;
  padding-bottom: 73px;
}
.line::before {
  content: "";
  position: absolute;
  display: block;
  width: 370px;
  border-top: 1px solid #000000;
  top: 26px;
}
.line::after {
  content: "";
  position: absolute;
  display: block;
  width: 370px;
  border-top: 1px solid #000000;
  right: 0;
  top: 26px;
}

/* 方案架构图片 */
.apply_img {
    width: 925px;
    height: 429px;
    margin: 0 auto;
    margin-bottom: 140px;
}
.apply_img img{
    width: 100%;
    height: 100%;
}

/* 弹性盒子中的文字 */
.apply_listp {
    text-align: center;
    font-size: 24px;
    margin-top: 12px;
    margin-bottom: 30px;
    color: #333333;
}

.img_box {
    position: relative;
}
/* 图片上的文字 */
.img_text {
    font-size: 24px;
    color: #ffffff;
    display: block;
    width: 100px;
    height: 36px;
    border-bottom: 1px solid #ffffff;
}
.img_opcity ul {
    margin-top: 15px;
}
.img_opcity li {
    list-style: none;
    font-size: 14px; 
    margin-top: 10px;
    color: #ffffff;
}
.img_opcity li span {
    display: block;
    width: 10px;
    height: 10px;
    background: #ffffff;
    border-radius: 50%;
    float: left;
    margin-right: 13px;
    margin-top: 4px;
}


/* 图片蒙层 */
.img_opcity {
    width: 310px;
    height: 233px;
    padding: 24px 10px 10px;
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
}
.img_opcity:hover { 
    opacity: 1;
}

/* 下方图片过渡效果 */
.img_hover img {
    transition: all .5s;
}
.img_hover img:hover {
    /* position: absolute; */
    box-shadow: #646464 0 0 13px;
    transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/client/client.vue